import script from "./ProductFinancial.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductFinancial.vue?vue&type=script&setup=true&lang=ts"

import "./ProductFinancial.vue?vue&type=style&index=0&id=03c19746&scoped=true&lang=css"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c19746"]])

export default __exports__